import { IWidgetType, Widget, WidgetRepository } from '@framework/engine';

/**
 * Ritorna la direzione di sorting utilizzata per il layout dei widget
 */
export function sortingStrategyDirection(
  widget?: Widget,
  widgetType?: IWidgetType<Widget> | null,
) {
  const wType = widgetType ?? WidgetRepository.find(widget?.type);

  return wType?.childrenLayoutStrategy ?? 'vertical';
}
